function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 130,
    viewBox: "0 0 140 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M116.62 57.6732C114.843 59.3814 113.864 61.7049 113.916 64.1164C113.916 64.4053 113.916 64.7067 113.916 64.9956C113.916 90.7055 91.2265 111.429 64.0829 109.608C41.1715 108.063 22.6098 90.2283 21.0162 68.1984C19.1222 42.0991 40.662 20.2827 67.4138 20.2827C71.646 20.2827 75.7606 20.8353 79.6532 21.8652C82.8927 22.7193 86.3673 21.8903 88.7447 19.6044L100.331 8.46388C89.6068 2.6738 77.1061 -0.390792 63.8086 0.274878C29.9117 1.99557 2.32397 28.1577 0.142552 60.7378C-2.49605 100.213 31.858 132.844 73.0567 129.591C105.66 127.029 131.877 101.758 134.581 70.4214C135.39 61.0267 134.071 52.0213 131.08 43.757L116.607 57.6732H116.62Z",
    fill: "#FCC226",
    fillOpacity: 0.05,
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 21.1556L127.649 9.26646C124.047 5.79985 118.223 5.79985 114.622 9.26646L67.6742 54.4575L48.6794 36.1734L29.8147 54.3324L48.6534 72.7667L67.5182 90.9258L67.6742 90.7756L67.8302 90.9258L86.695 72.7667L86.5389 72.6166L140 21.1556Z",
    fill: "#FCC226",
    fillOpacity: 0.05,
    style: {
      fill: "#FCC226",
      fill: "color(display-p3 0.9882 0.7608 0.1490)",
      fillOpacity: 0.05
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c091851494e5aa08332f7bdd22982962.svg";
export { ForwardRef as ReactComponent };